import { render, staticRenderFns } from "./MobileQuestionnaire.vue?vue&type=template&id=56cba9be&"
import script from "./MobileQuestionnaire.vue?vue&type=script&lang=js&"
export * from "./MobileQuestionnaire.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports